import { defineComponent as x, ref as k, watch as M, nextTick as B, openBlock as c, createBlock as f, Teleport as E, createElementVNode as a, normalizeClass as o, withModifiers as b, withCtx as L, createVNode as $, unref as T, createCommentVNode as y, renderSlot as d, createElementBlock as z } from "vue";
import "./js.cookie.CkZE2oaL.js";
import { _ as H } from "./BaseButton.vue_vue_type_script_setup_true_lang.dlLTK59i.js";
import { l as O } from "./CloseIcon._moEkaop.js";
import "./DownloadIcon.DHCHRETy.js";
import '../assets/BaseModal.css';const I = (l, n) => new Promise((s, u) => {
  setTimeout(() => {
    try {
      l && l(), s();
    } catch {
      u();
    }
  }, n);
}), K = ["id", "data-cy"], N = ["innerHTML"], j = /* @__PURE__ */ x({
  __name: "BaseModal",
  props: {
    id: { default: "base-bt-modal" },
    size: { default: "modal-md" },
    customBackdropClasses: { default: "" },
    customModalDialogClasses: { default: "" },
    customModalHeaderClasses: { default: "" },
    customModalBodyClasses: { default: "" },
    customModalFooterClasses: { default: "" },
    withCloseIcon: { type: Boolean, default: !0 },
    showModal: { type: Boolean, default: !0 },
    closeIcon: { default: "" },
    headerTitle: { default: "" },
    autoClose: {},
    fullHeight: { type: Boolean, default: !1 },
    closeOnClickOut: { type: Boolean, default: !0 },
    centered: { type: Boolean, default: !1 }
  },
  emits: ["closed", "opened"],
  setup(l, { emit: n }) {
    const s = l, u = n, e = k(!1), r = k(null), h = k(null), m = ({ key: t }) => {
      t === "Escape" && i();
    }, w = () => {
      document.body.addEventListener("keydown", m);
    }, v = () => {
      document.body.removeEventListener("keydown", m);
    }, C = async () => {
      e.value = !0, w(), document.documentElement.classList.add("uikit-no-scrolling"), document.body.classList.add("uikit-no-scrolling", "sm:uikit-pr-15px"), u("opened"), s.autoClose !== void 0 && setTimeout(() => {
        i();
      }, s.autoClose);
    }, g = async () => {
      s.closeOnClickOut && await i();
    }, i = async () => {
      e.value = !1, v(), document.body.classList.remove("uikit-no-scrolling", "sm:uikit-pr-15px"), document.documentElement.classList.remove("uikit-no-scrolling"), await I(() => {
        r.value?.classList.add("uikit-hidden"), u("closed");
      }, 250);
    };
    return M(
      () => s.showModal,
      async (t) => {
        !t && !e.value && B(() => {
          r.value?.classList.add("uikit-hidden");
        }), t && !e.value && await C(), !t && e.value && await i(), e.value = t;
      },
      { immediate: !0 }
    ), (t, p) => (c(), f(E, { to: "body" }, [
      a("div", {
        ref_key: "backdropEl",
        ref: r,
        class: o(["bbt-backdrop uikit-fixed uikit-left-0 uikit-top-0 uikit-h-full uikit-w-full", [
          t.customBackdropClasses,
          {
            "uikit-animate-[backdrop-opacity_0.3s_ease-out_0s_backwards] uikit-bg-w-secondary/70": e.value
          },
          { "uikit-bg-transparent": !e.value },
          { "sm:uikit-pt-[30px]": !t.centered }
        ]]),
        style: { "z-index": "1062" },
        onClick: g
      }, [
        a("dialog", {
          id: t.id,
          ref_key: "modalEl",
          ref: h,
          "data-cy": t.$attrs["data-cy"],
          class: o(["uikit-modal-dialog transition-y uikit-mx-auto uikit-block uikit-w-full uikit-overflow-y-auto uikit-overflow-x-hidden uikit-rounded uikit-border-none uikit-bg-transparent uikit-bg-white uikit-p-0 uikit-shadow-lg uikit-no-scrollbar uikit-safe-bottom max-sm:uikit-fixed max-sm:uikit-bottom-0 max-sm:uikit-max-h-[95%] max-sm:uikit-rounded-bl-none max-sm:uikit-rounded-br-none sm:uikit-h-auto", [
            t.customModalDialogClasses,
            { "show ": e.value },
            { "closed uikit-overflow-hidden": !e.value },
            { centered: t.centered },
            `base-${t.size}`,
            t.fullHeight ? "uikit-h-[95%]" : "uikit-h-auto"
          ]]),
          onClick: p[0] || (p[0] = b(() => {
          }, ["stop"]))
        }, [
          a("div", {
            class: o(["default-header uikit-sticky uikit-top-0 uikit-z-10 uikit-rounded-t uikit-border-0 uikit-bg-white uikit-px-4 uikit-pb-10px uikit-pt-20px sm:uikit-px-6", [t.customModalHeaderClasses]])
          }, [
            t.withCloseIcon ? (c(), f(H, {
              key: 0,
              id: "close-icon-btn",
              "data-cy": "bbt-default-close-icon-btn",
              class: o(["uikit-absolute uikit-right-15px uikit-top-15px uikit-z-10 uikit-bg-transparent", t.$attrs["close-icon-btn-classes"]]),
              type: "button",
              "aria-label": "Close",
              "is-empty": !0,
              onClick: b(i, ["prevent", "stop"])
            }, {
              default: L(() => [
                $(T(O), {
                  class: "bbt-close-icon uikit-box-border uikit-p-5px",
                  width: 30,
                  height: 30
                })
              ]),
              _: 1
            }, 8, ["class"])) : y("", !0),
            d(t.$slots, "header", { closeModal: i }, () => [
              a("span", {
                class: o(["uikit-w-auto uikit-text-18 uikit-font-semibold sm:uikit-text-22", t.$attrs["title-classes"]]),
                innerHTML: t.headerTitle
              }, null, 10, N)
            ])
          ], 2),
          a("div", {
            class: o(["uikit-bbt-body uikit-flex-auto uikit-overflow-y-auto uikit-overflow-x-hidden uikit-px-4 uikit-pb-0 uikit-no-scrollbar sm:uikit-px-6 sm:uikit-pb-25px", [t.customModalBodyClasses]])
          }, [
            d(t.$slots, "body")
          ], 2),
          t.$slots.footer ? (c(), z("div", {
            key: 0,
            class: o(["uikit-bbt-footer uikit-sticky uikit-bottom-0 uikit-border-0 uikit-bg-white uikit-px-4 uikit-py-15px sm:uikit-px-6", t.customModalFooterClasses])
          }, [
            d(t.$slots, "footer", { closeModal: i })
          ], 2)) : y("", !0),
          d(t.$slots, "fixed-bottom")
        ], 10, K)
      ], 2)
    ]));
  }
});
export {
  j as _
};
